import { createContext } from "react";

export interface IRidesCalendarContext {
  ridesCalendarHeight: number;
  ridesCalendarWidth: number;
}

export const ridesCalendarDefaultContext: IRidesCalendarContext = {
  ridesCalendarHeight: 0,
  ridesCalendarWidth: 0,
};

export const RidesCalendarContext = createContext<IRidesCalendarContext>(
  ridesCalendarDefaultContext,
);
